interface ShortcutsPageProps {
  onShortcut: (message: string) => void
}

const SHORTCUTS = [
  { label: 'Deep research',   message: 'Run deep research'   },
  { label: 'Cobill research', message: 'Run cobill research' },
  { label: 'Show research',   message: 'Run show research'   },
  { label: 'Find naked dates', message: 'Find naked dates'  },
  { label: 'Find open dates',  message: 'Find open dates'   },
]

export default function ShortcutsPage({ onShortcut }: ShortcutsPageProps) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 24px',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '16px',
          width: '100%',
          maxWidth: 480,
        }}
      >
        {SHORTCUTS.map(({ label, message }) => (
          <button
            key={label}
            onClick={() => onShortcut(message)}
            style={{
              padding: '28px 16px',
              borderRadius: '12px',
              background: 'var(--surface)',
              border: '1px solid var(--border)',
              color: 'var(--accent)',
              fontSize: '14px',
              fontWeight: 500,
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'background 0.15s',
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  )
}
